import type {
  OrganizationSearchEstablishment,
  OrganizationSearchResult,
} from '../types/organization-search-result.type';

export const buildOrganizationName = (
  result: Readonly<OrganizationSearchResult>,
  establishment: Readonly<OrganizationSearchEstablishment>,
): string => {
  const companyName = result.nom_raison_sociale ?? result.nom_complet;
  const distinguisher =
    establishment.nom_commercial ??
    establishment.liste_enseignes?.[0] ??
    establishment.libelle_commune;

  return distinguisher && !companyName.includes(distinguisher)
    ? `${companyName} - ${distinguisher}`
    : companyName;
};
